import { Typography } from "@mui/material";
import React, { ReactElement } from "react";

import { RenderingObjectKind } from "../../../generated/gql/graphql";
import ProductList, {
  ProductListProps,
} from "../../lists/product/product-list";

import { CanvasObject } from "./canvas-object";

/** Maximum number of presentation objects */
export const MaxCanvasPresentationObjects = 10;

export type ProductsPanelProps = Pick<
  ProductListProps,
  "selectedProductId" | "productSelected" | "query" | "filters" | "gridSize"
> & {
  canvasObjects: CanvasObject[];
};

export default function ProductsPanel(props: ProductsPanelProps): ReactElement {
  const {
    selectedProductId,
    canvasObjects,
    productSelected,
    query,
    filters,
    gridSize,
  } = props;

  const canvasPresentationObjectsCount =
    canvasObjects?.filter(
      (obj) => obj.kind === RenderingObjectKind.Presentation,
    )?.length ?? 0;
  const isEditorObjectsMaxLimit =
    canvasPresentationObjectsCount >= MaxCanvasPresentationObjects;

  return (
    <div className="flex h-full min-h-0 flex-col">
      {isEditorObjectsMaxLimit ? (
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center">
          <Typography className="p-5 text-center font-bold uppercase text-companyMediumGrey">
            Maximum number of products reached
          </Typography>
          <Typography className="text-center font-semibold text-companyMediumGrey">
            You have already added {canvasPresentationObjectsCount}/
            {MaxCanvasPresentationObjects}
            products. Please delete a product from the scene to add a new one.
          </Typography>
        </div>
      ) : (
        <ProductList
          query={query}
          filters={filters}
          gridSize={gridSize}
          selectedProductId={selectedProductId}
          productSelected={productSelected}
        />
      )}
    </div>
  );
}
